import { useCallback, useRef } from 'react';
import { useUnmount } from 'ahooks';
import { Toast } from '@/components';
import service from '@/service';

/** 设备底盘停驻解锁提示 */
export const useChassisStatePrompt = () => {
  const deviceChassisState = useRef<DeviceItem['chassisState']>(null);
  const deviceChassisLoopTimer = useRef<NodeJS.Timeout>(null);

  const getDeviceChassisState = useCallback(async (deviceId: string, showErrorMsg = false) => {
    if (!deviceId) return;

    const { data } = await service.device.getChassisStateByDeviceId(deviceId);

    switch (data?.state) {
      case 'Locking':
        deviceChassisState.current = 'Locking';
        showErrorMsg && Toast.fail('正在进行底盘停驻，不允许操作');
        break;
      case 'Unlocking':
        deviceChassisState.current = 'Unlocking';
        showErrorMsg && Toast.fail('正在进行底盘解锁，不允许操作');
        break;
      case 'Static':
        if (deviceChassisState.current === 'Locking') {
          Toast.show(`机器${deviceId}底盘停驻成功`);
        } else if (deviceChassisState.current === 'Unlocking') {
          Toast.show(`机器${deviceId}底盘解锁成功`);
        }
        clearInterval(deviceChassisLoopTimer.current);
        deviceChassisState.current = null;
        break;
    }
  }, []);

  /** 当点击创建服务时底盘正在停驻或解锁时，轮询当前机器底盘状态并提示 */
  const loopGetDeviceChassisState = useCallback(
    async (deviceId: string) => {
      if (!deviceId) return;

      getDeviceChassisState(deviceId, true);

      // 当前正在轮询该设备的状态，则不再发起新的轮询
      if (deviceChassisLoopTimer.current) return;

      deviceChassisLoopTimer.current = setInterval(() => getDeviceChassisState(deviceId, false), 2000);
    },
    [getDeviceChassisState]
  );

  useUnmount(() => {
    deviceChassisLoopTimer.current && clearInterval(deviceChassisLoopTimer.current);
  });

  return {
    loopGetDeviceChassisState,
  };
};
